import { Box } from '@mui/material';
import React from 'react';

function InfoIcon({ sx = {}, ...props }) {
    return (
        <Box
            component={'svg'}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
            sx={{
                width: '20px',
                height: '20px',
                minWidth: '20px',
                minHeight: '20px',

                ...sx,
            }}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.3333 10.0001C18.3333 14.6026 14.6025 18.3334 9.99996 18.3334C5.39746 18.3334 1.66663 14.6026 1.66663 10.0001C1.66663 5.39758 5.39746 1.66675 9.99996 1.66675C14.6025 1.66675 18.3333 5.39758 18.3333 10.0001ZM10.8333 6.66675C10.8333 6.88776 10.7455 7.09972 10.5892 7.256C10.4329 7.41228 10.221 7.50008 9.99996 7.50008C9.77894 7.50008 9.56698 7.41228 9.4107 7.256C9.25442 7.09972 9.16662 6.88776 9.16662 6.66675C9.16662 6.44573 9.25442 6.23377 9.4107 6.07749C9.56698 5.92121 9.77894 5.83341 9.99996 5.83341C10.221 5.83341 10.4329 5.92121 10.5892 6.07749C10.7455 6.23377 10.8333 6.44573 10.8333 6.66675ZM9.99996 8.33341C9.77894 8.33341 9.56698 8.42121 9.4107 8.57749C9.25442 8.73377 9.16662 8.94573 9.16662 9.16675V13.3334C9.16662 13.5544 9.25442 13.7664 9.4107 13.9227C9.56698 14.0789 9.77894 14.1667 9.99996 14.1667C10.221 14.1667 10.4329 14.0789 10.5892 13.9227C10.7455 13.7664 10.8333 13.5544 10.8333 13.3334V9.16675C10.8333 8.94573 10.7455 8.73377 10.5892 8.57749C10.4329 8.42121 10.221 8.33341 9.99996 8.33341Z"
                fill="currentColor"
            />
        </Box>
    );
}

export default InfoIcon;
